export default __webpack_public_path__ + "static/pot-09572c9ca5029c5e65ea683d180996ea.png";